// Utility to clear organization locks
// Can be run from browser console: window.clearOrganizationLocks()

export function clearOrganizationLocks() {
  console.log('🧹 Clearing organization locks...')
  
  const keysToRemove = [
    'locked-organization-id',
    'locked-organization-timestamp',
    'selectedOrganizationId',
    'last-known-org-id',
    'organization_session',
    'cached_profile'
  ]
  
  keysToRemove.forEach(key => {
    const value = localStorage.getItem(key)
    if (value) {
      console.log(`Removing ${key}:`, value)
      localStorage.removeItem(key)
    }
  })
  
  // Clear any supabase auth keys that might have org data
  const allKeys = Object.keys(localStorage)
  allKeys.forEach(key => {
    if (key.includes('organization') || key.includes('org-')) {
      console.log(`Removing ${key}`)
      localStorage.removeItem(key)
    }
  })
  
  console.log('✅ All organization locks cleared!')
  console.log('Please refresh the page now.')
  
  return 'Locks cleared - refresh the page!'
}

// Make it available globally
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).clearOrganizationLocks = clearOrganizationLocks
}